import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Subtitulo } from '@monorepo-web/components-library';
import { getLayouts } from './layouts';
import TabelaBase from '../../library/TabelaBase';
import { Grid } from '@mui/material';
export default function TabelaPosicaoRendimento(props) {
    const { titulo, rows, layout, renderTogglePercent, moneyPrefix } = props;
    return (_jsxs(Grid, Object.assign({ container: true, sx: { marginTop: 3 } }, { children: [titulo ? _jsx(Subtitulo, Object.assign({ mb: "8px" }, { children: titulo })) : null, renderTogglePercent, _jsx(Grid, Object.assign({ item: true, xs: 12 }, { children: _jsx(TabelaBase, { rows: rows, layout: layout, layouts: getLayouts(moneyPrefix), height: 300 }) }))] })));
}
